var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.07143C16 5.81762 14.6044 7.2381 12.8889 7.2381C11.1733 7.2381 9.77778 5.81762 9.77778 4.07143C9.77778 2.32524 11.1733 0.904766 12.8889 0.904766C14.6044 0.904766 16 2.32524 16 4.07143ZM14.2222 8.85762C13.7778 8.97524 13.3333 9.04762 12.8889 9.04762C11.593 9.04523 10.3509 8.52019 9.43452 7.58749C8.51818 6.65479 8.00235 5.39047 8 4.07143C8 2.74143 8.51556 1.5381 9.33333 0.642386C9.17202 0.441113 8.96862 0.279006 8.73796 0.167878C8.5073 0.0567495 8.25519 -0.000601218 8 4.75243e-06C7.02222 4.75243e-06 6.22222 0.81429 6.22222 1.80953V2.07191C3.58222 2.8681 1.77778 5.3381 1.77778 8.14286V13.5714L0 15.381V16.2857H16V15.381L14.2222 13.5714V8.85762ZM8 19C8.98667 19 9.77778 18.1948 9.77778 17.1905H6.22222C6.22222 17.6704 6.40952 18.1307 6.74292 18.47C7.07632 18.8094 7.5285 19 8 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.2b9fe1741cedb51bb5a8d88812d5dc94.svg";
export { ForwardRef as ReactComponent };